export default "__VITE_ASSET__CfNBCECz__"